var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.0376C8.63472 7.0376 5.67213 8.92631 4.05808 11.7796C3.98064 11.9164 3.98064 12.0834 4.05808 12.2203C5.67213 15.0736 8.63472 16.9623 12 16.9623C15.3653 16.9623 18.3279 15.0736 19.9419 12.2203C20.0194 12.0834 20.0194 11.9164 19.9419 11.7796C18.3279 8.92631 15.3653 7.0376 12 7.0376ZM2.31731 10.7948C4.25759 7.36488 7.85749 5.0376 12 5.0376C16.1425 5.0376 19.7424 7.36488 21.6827 10.7948C22.1058 11.5427 22.1058 12.4572 21.6827 13.2051C19.7424 16.635 16.1425 18.9623 12 18.9623C7.85749 18.9623 4.25759 16.635 2.31731 13.2051C1.89423 12.4572 1.89423 11.5427 2.31731 10.7948ZM12 9.59289C10.6706 9.59289 9.59295 10.6706 9.59295 11.9999C9.59295 13.3293 10.6706 14.407 12 14.407C13.3294 14.407 14.4071 13.3293 14.4071 11.9999C14.4071 10.6706 13.3294 9.59289 12 9.59289ZM7.59295 11.9999C7.59295 9.56599 9.56605 7.59289 12 7.59289C14.4339 7.59289 16.4071 9.56599 16.4071 11.9999C16.4071 14.4339 14.4339 16.407 12 16.407C9.56605 16.407 7.59295 14.4339 7.59295 11.9999Z",
    fill: "#8C8F96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.96cbe1fda70af47c990c98315b43f669.svg";
export { ForwardRef as ReactComponent };